import { UsaColored, VietnamColored } from '@teko/ds-icon';
import { TopbarDropdown } from '@teko/teko-ecommerce';
import { useTenantConfig } from 'contexts';
import { setCookieByName } from 'helpers';
import React from 'react';
import { t } from 'i18n';

export const LanguageSelector: React.FC = () => {
  const { currentLanguage, availableLanguages } = useTenantConfig();

  const options =
    availableLanguages?.map((language) => {
      switch (language) {
        case 'vi':
          return {
            text: t('Tiếng Việt'),
            value: language,
            icon: <VietnamColored />,
          };
        case 'en':
          return {
            text: t('English'),
            value: language,
            icon: <UsaColored />,
          };
        default:
          return {
            text: t('Ngôn ngữ khác'),
            value: language,
            icon: <VietnamColored />,
          };
      }
    }) || [];

  const onSelectLanguage = (value: string | number): void => {
    // UX4BUYER-4531
    // make sure passed value is string
    const language = value.toString();
    const currentDate = new Date();
    const date = new Date(
      currentDate.getFullYear() + 1,
      currentDate.getMonth(),
      currentDate.getDay(),
    );
    const expireDate = date.toUTCString();

    const newUrl = new URL(window.location.href);

    setCookieByName('lang', language, expireDate, '/');

    newUrl.searchParams.set('lang', language);
    window.location.href = newUrl.href;
  };

  return !!currentLanguage &&
    !!availableLanguages?.length &&
    availableLanguages.length > 1 ? (
    <TopbarDropdown
      key={3}
      value={currentLanguage}
      selectValue={onSelectLanguage}
      options={options}
    />
  ) : null;
};
